export default __webpack_public_path__ + "25fe5340a994ec674c2177751dbc29fd.svg";